import React, {useState} from 'react'
import {ListItem} from '../../../styled'
import { ReactComponent as Email } from 'images/icons/email.svg'
import { ReactComponent as Messenger } from 'images/icons/messenger.svg'
import { ReactComponent as Whatsapp } from 'images/icons/whatsapp.svg'
import { ReactComponent as Sms } from 'images/icons/sms.svg'
import { ReactComponent as Widget } from 'images/icons/widget.svg'
import { ReactComponent as Phone } from "images/icons/phone.svg"
import { ReactComponent as Video } from "images/icons/video.svg"
import {Container, ChannelList} from './styled'
import classNames from "classnames";
import Checkbox from "@material-ui/core/Checkbox";
import {pathChannel} from "../../../../routes/path";

const Channel = props => {
    const {t, count} = props
    const {filter, setFilter} = props.filter
    const [channel, setChannel] = useState({
        selected: filter.channel ? filter.channel : pathChannel,
        haveAll: !filter.channel || filter.channel.length === pathChannel.length
    })
    const all = !filter.channel || filter.channel.length === pathChannel.length


    function getCount(channel) {
        let bot = 0,
            human = 0

        const allCount = (Array.isArray(count) && count.length > 0 )? count.filter(x => Array.isArray(filter.department) && filter.department.includes(x.department_id)) : []
        allCount && allCount.map(x => x[channel] && Object.keys(x[channel]).map(z => !/\W*(closed)\W*/.test(z) && z !== 'expired' && z !== 'in_day' && z !== 'will_delay' && (!props.auth || props.auth.role > 1 || z !== 'waiting') && (/\W*(bot)\W*/.test(z) ? bot += x[channel][z] : human += x[channel][z])))
        return filter && filter.type === 'human' ? human : (filter.type === 'bot' ? bot : (bot + human))
    }

    function getCountExpired(channel) {
        let expired = 0
        if (count) {
        const allCount = (count && Array.isArray(count) && count.length > 0) ? count.filter(x => Array.isArray(filter.department) && filter.department.includes(x.department_id)) : []
        allCount && allCount.map(x => x[channel] && (expired += x[channel]['expired']))
        }
        return expired
    }

    return (<Container className={classNames({hidden: ( getCount(1) === 0 && getCount(2) === 0 && getCount(3) === 0 && getCount(4) === 0 && getCount(5) === 0 && getCount(6) === 0 && getCount(7) === 0) })}>
            <h5>{t.Channel.title}
                <button onClick={() => setFilter({channel: all ? [] : pathChannel})}>
                    <Checkbox checked={all} color="primary" classes={{root: 'checkbox'}}/>{t.selectAll}</button>
            </h5>
            <ChannelList noColor badgeColor="#000" paddingChildren="1rem" height="3.5rem" iconSize="1.5rem"
                                   fontSize=".75rem" centerChildren>
                <ListItem icon={<Widget/>} title={'Chat'} badgeColor='#5739EA' badge={getCount(1)} badgeExpired={getCountExpired(1)}
                          onClick={() => setFilter({channel: filter.channel && filter.channel.includes(1) ? filter.channel.filter(x => x !== 1) : [...filter.channel, 1]})}
                          className={classNames({active: Array.isArray(filter.channel) && filter.channel.includes(1), hidden:getCount(1) === 0}, 'widget')}/>
                <ListItem icon={<Video/>} title={'Video'} badgeColor='#108b7f' badge={getCount(7)} badgeExpired={getCountExpired(7)}
                          onClick={() => setFilter({channel: filter.channel.includes(7) ? filter.channel.filter(x => x !== 7) : [...filter.channel, 7]})}
                          className={classNames({active: Array.isArray(filter.channel) && filter.channel.includes(7), hidden:getCount(7) === 0}, 'video')}/>
                <ListItem icon={<Whatsapp/>} title={'WhatsApp'} badgeColor='#53cd5e' badge={getCount(2)} badgeExpired={getCountExpired(2)}
                          onClick={() => setFilter({channel: filter.channel.includes(2) ? filter.channel.filter(x => x !== 2) : [...filter.channel, 2]})}
                          className={classNames({active: Array.isArray(filter.channel) && filter.channel.includes(2), hidden:getCount(2) === 0}, 'whatsapp')}/>
                <ListItem icon={<Sms/>} title={'Sms'} badgeColor='#26c6da' badge={getCount(3)} badgeExpired={getCountExpired(3)}
                          onClick={() => setFilter({channel: filter.channel.includes(3) ? filter.channel.filter(x => x !== 3) : [...filter.channel, 3]})}
                          className={classNames({active: Array.isArray(filter.channel) && filter.channel.includes(3), hidden:getCount(3) === 0}, 'sms')}/>
                <ListItem icon={<Email/>} title={'E-mail'} badgeColor='#ffca28' badge={getCount(4)} badgeExpired={getCountExpired(4)}
                          onClick={() => setFilter({channel: filter.channel.includes(4) ? filter.channel.filter(x => x !== 4) : [...filter.channel, 4]})}
                          className={classNames({active: Array.isArray(filter.channel) && filter.channel.includes(4), hidden:getCount(4) === 0}, 'email')}/>
                <ListItem icon={<Messenger/>} title={'Messenger'} badgeColor='#007ff7' badge={getCount(5)} badgeExpired={getCountExpired(5)}
                          onClick={() => setFilter({channel: filter.channel.includes(5) ? filter.channel.filter(x => x !== 5) : [...filter.channel, 5]})}
                          className={classNames({active: Array.isArray(filter.channel) && filter.channel.includes(5), hidden:getCount(5) === 0}, 'messenger')}/>
                <ListItem icon={<Phone/>} title={'Telefone'} badgeColor='#cd2721' badge={getCount(6)} badgeExpired={getCountExpired(6)}
                          onClick={() => setFilter({channel: filter.channel.includes(6) ? filter.channel.filter(x => x !== 6) : [...filter.channel, 6]})}
                          className={classNames({active: Array.isArray(filter.channel) && filter.channel.includes(6), hidden:getCount(6) === 0}, 'phone')}/>
            </ChannelList>
        </Container>
    )
}

export default Channel